import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1637286297960"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2118"
      width="32"
      height="32"
    >
      <path
        d="M914.691674 123.697006H109.30935c-47.583643 0-86.289099 38.70648-86.2891 86.290123v603.998113c0 47.583643 38.705456 86.317752 86.2891 86.317752h805.382324c47.58262 0 86.288076-38.734109 86.288076-86.317752V209.987129c0-47.58262-38.705456-86.290123-86.288076-86.290123z m-15.169461 57.497414l-387.51505 335.861726-387.530399-335.861726h775.045449z m15.169461 661.581484H109.30935c-11.670784 0-21.62958-7.049542-26.138258-17.050293l274.221977-219.374921-35.955838-44.913843-240.893984 192.718871V219.283847l431.462893 373.892825L943.454707 219.283847v534.871871l-240.891938-192.718871-35.955838 44.913843L940.812535 825.724587c-4.491282 10.001775-14.49408 17.051317-26.120861 17.051317z"
        fill="#8a8a8a"
        p-id="2119"
      />
    </svg>
  )
}
const UserNameIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
UserNameIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
UserNameIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default UserNameIcon
